import React from 'react'
import styled from 'styled-components'
import { Box, Text, Image, Tooltip, Flex, colors } from 'pcln-design-system'
import PropTypes from 'prop-types'

const CustomTooltip = styled(Tooltip)`
  display: none;
`

const LogoContainer = styled(Flex)`
  &:hover ${CustomTooltip} {
    display: block;
  }
`

const IMAGE_SIZE = {
  small: {
    height: ['16px', '20px'],
  },
  large: {
    height: ['18px', '28px'],
  },
}
const IMAGE_SIZE_BT = {
  small: {
    height: '8px',
    width: '32px',
  },
  large: {
    height: '16px',
    width: '50px',
  },
}

const getCarrierName = (carrier) => {
  return carrier.name.split(' ')[0] === 'Air' ? carrier.name : carrier.name.split(' ')[0]
}

const TrustedAirlines = ({ airlines, logoUrl, content, size, ...props }) => {
  return (
    <Flex {...props} flexDirection={'column'} alignItems={'flex-start'} width={1}>
      {content && airlines?.length > 0 && (
        <Text data-test='data-exclusive' fontSize={0} mr={[2, 3, 3, 3, 3]}>
          {content}:
        </Text>
      )}

      {airlines.length > 0 && (
        <Flex data-test='exd-carriers-images' flexWrap={'wrap'} mt={2}>
          {airlines.map((carrier, index) => {
            const isBritishAirways = carrier?.name?.toLowerCase() === 'british airways'
            return (
              <LogoContainer
                key={index}
                alignItems={'center'}
                flexDirection={size === 'large' ? 'column' : 'row'}
                mr={size === 'small' ? [2, 3, 3, 3, 3] : [3, 4, 4, 4, 4]}
                justifyContent={'center'}
                mb={[2, 2]}
              >
                <Box>
                  <CustomTooltip top left color='background.darkest' ml='-10px' mb={3}>
                    {carrier.name}
                  </CustomTooltip>
                  <Image
                    data-test='carrier-image'
                    src={carrier.logo ? carrier.logo : logoUrl + carrier.image}
                    alt={carrier.name}
                    className={'hero-image'}
                    height={isBritishAirways ? IMAGE_SIZE_BT[size].height : IMAGE_SIZE[size].height}
                    width={isBritishAirways && IMAGE_SIZE_BT[size].width}
                    mt={isBritishAirways && '2px'}
                    mb={isBritishAirways && '3px'}
                    mr={size === 'small' ? 2 : 0}
                    loading='lazy'
                  />
                </Box>

                <Text
                  data-test='carrier-name'
                  fontSize={0}
                  color={colors.gray}
                  textAlign={'center'}
                  mt={size === 'large' && [1, 2]}
                >
                  {getCarrierName(carrier)}
                </Text>
              </LogoContainer>
            )
          })}
        </Flex>
      )}
    </Flex>
  )
}

TrustedAirlines.defaultProps = {
  airlines: [],
  logoUrl: 'https://s1.pclncdn.com/design-assets/fly/carrier-logos/',
  size: 'small',
}

TrustedAirlines.propTypes = {
  airlines: PropTypes.arrayOf(
    PropTypes.shape({
      logo: PropTypes.string,
      name: PropTypes.string,
      image: PropTypes.string,
    })
  ),
  logoUrl: PropTypes.string,
  content: PropTypes.string,
  size: PropTypes.string,
}

export { TrustedAirlines }
